module.exports = __webpack_public_path__ + "img/zhlc-1.55819896.png";